/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Alert,
  Col,
  Row,
  Card,
  Accordion,
  Button,
  Form,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { InssuredData } from "../../subPages/InsuredData/InssuredData";
import { HospitalData } from "../../subPages/HospitalData/HospitalData";
import { Documentation } from "../../subPages/Documentation/Documentation";
import { Binnacle } from "../../subPages/Binnacle/Binnacle";
import { MedicalOpinionData } from "../../subPages/MedicalOpinionData/MedicalOpinionData";
import { MedicalDataAdditional } from "../../subPages/AdditionalMedicalData/MedicalDataAdditional";
import { AuthLetters } from "../../subPages/AuthLetter/AuthLetters";
import { ProvidersData } from "../../subPages/SurgeryProvidersData/ProvidersData";
import {
  getBySlug,
  update,
} from "../../services/hospitalizationcrud";
import {
  getLastLetterMovByCase,
  getLetterMovsByCase,
} from "../../services/letterMovsService";
import { MedicAssigned } from "../../subPages/MedicAssigned/MedicAssigned";
import moment from "moment";
import { isEmpty } from "../../../_utils/checkObjectEmpty";
import { MedicAssignationTrakingMedic } from "../../subPages/MedicAssignationTracking/MedicAssignationTrackingMedic";
import { IfHasRole } from "../../../../_metronic/_helpers";
import { MedicalFees } from "../../subPages/MedicalFee/MedicalFees";
import CaseHeader from "../../subPages/CaseHeader/CaseHeader";
import BlockCaseContext from "../../../contexts/BlockCaseContext";
import $ from "jquery";
import swal from "sweetalert";

const MedicalOpinionDetails = (props) => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("DICTAMEN MÉDICO");

  const { slug } = props.match.params;

  const [caseRecord, setCaseRecord] = useState({});
  const [letterMov, setLetterMov] = useState({});
  const [letterMovs, setLetterMovs] = useState([]);
  const [totalLetters, setTotalLetters] = useState("0");
  const [isFinalReject, setIsFinalReject] = useState(false);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);
  const [sectionErrors, setSectionErrors] = useState({
    medicalOpinionData: false,
    binnacle: false,
  });

  useEffect(() => {
    window.wasCommented = false;
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      setIsFinalReject(response.data.statusDictum === "Rechazo Definitivo")
      getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
        setLetterMov(currrentLetterMov.data)
      );
    });
  }, [slug]);

  let history = useHistory();
  let submitMedicalOpinionData = null;
  let submitMedicalDataAdditional = null;
  let submitMedicalOpinionDataErrors = null;

  const query = new URLSearchParams(props.location.search);

  const bindSubmitFormMedicalOpinionData = (submitForm) =>
    (submitMedicalOpinionData = submitForm);

  const bindSubmitFormMedicalDataAdditional = (submitForm) =>
    (submitMedicalDataAdditional = submitForm);

    const bindSubmitMedicalOpinionErrors = (errors) =>
    (submitMedicalOpinionDataErrors = errors);

  let submitFormMedicAssignation = null;
  let submitFormMedicAssignationErrors = null;

  const bindSubmitFormMedicAssignation = (submitForm) =>
    (submitFormMedicAssignation = submitForm);

  const bindSubmitFormMedicAssignationErrors = (errors) =>
    (submitFormMedicAssignationErrors = errors);

  const onClickSendControlDesk = async () => {
    await submitMedicalOpinionData();
    if (isEmpty(submitMedicalOpinionDataErrors)) {
      setSectionErrors(prev => ({ ...prev, medicalOpinionData: false }));
      let inputReasonControlDesk = document.getElementById(
        "reason_sendToControlDesk"
      ).value;
      if (inputReasonControlDesk === "") {
        swal("Error", "Debe seleccionar una razón", "error");
        return;
      }
      await submitMedicalOpinionData();
      if (!window.wasCommented) {
        setSectionErrors(prev => ({ ...prev, binnacle: true }));
        swal("Comentario requerido", "Debes guardar un comentario en la Bitácora antes de continuar", "warning");
        return;
      }
      setSectionErrors(prev => ({ ...prev, binnacle: false }));
      $("#btn_save_comment").click();
      let timestamp = await axios.get('/cases/getTimestamp');
      update(
        { caseStatusId: 2, reasonMC: inputReasonControlDesk, feamesaControl: moment.utc(timestamp.data).format() },
        caseRecord.id
      ).then((response) => {
        history.push("/dictamen_medico");
      });
    } else {
      setSectionErrors(prev => ({ ...prev, medicalOpinionData: true }));
      swal("Campos requeridos", "Completa los campos obligatorios en la sección DICTAMEN MÉDICO (Carta Suficiente, Estatus Dictamen)", "warning");
    }
  };

  const onClickCostControl = async () => {
    if (caseRecord.caseType === "Alta hospitalaria" && document.getElementById("si").value === "si" && !caseRecord.nurseFollowId) {
      swal("Error", "El caso no cuenta con Enfermer@ Asignad@ para el seguimiento en el siguiente modulo, favor de reportarlo a mesa de control", "error");
      return;
    }

    await submitMedicalOpinionData();
    if (isEmpty(submitMedicalOpinionDataErrors)) {
      setSectionErrors(prev => ({ ...prev, medicalOpinionData: false }));
      var someLetterAuthIsFinal;
      await submitMedicalDataAdditional();
      await getLetterMovsByCase(caseRecord?.id).then( result => {
        setLetterMovs(result.data);
        someLetterAuthIsFinal = result.data.some(letterMov => letterMov.letterType === "Final");
      });

      if (caseRecord.caseType !== "Reconsideracion de dictamen" && caseRecord.caseType !== "Alta express" && caseRecord.caseType !== "Revision de corte" && !isFinalReject) {
        if ( (caseRecord.caseType !== "Alta hospitalario" && caseRecord.caseType !== "Alta hospitalaria"
            && caseRecord.caseType !== "Reconsideración de Alta") || !document.getElementById('si').checked) {
          swal("Error", "No se puede enviar el caso a este Modulo porque no es Alta Hospitalaria y la Carta no es Suficiente.", "error");
          return;
        }
      }

      await submitMedicalOpinionData();
      if (!window.wasCommented) {
        setSectionErrors(prev => ({ ...prev, binnacle: true }));
        swal("Comentario requerido", "Debes guardar un comentario en la Bitácora antes de continuar", "warning");
        return;
      }
      setSectionErrors(prev => ({ ...prev, binnacle: false }));
      $("#btn_save_comment").click();
      let timestamp = await axios.get('/cases/localDateTime');
      update(
        { caseStatusId: 6, feaccostos: moment.utc(timestamp.data).format() },
        caseRecord.id
        ).then((response) => {
        history.push("/dictamen_medico");
      });
    } else {
      setSectionErrors(prev => ({ ...prev, medicalOpinionData: true }));
      swal("Campos requeridos", "Completa los campos obligatorios en la sección DICTAMEN MÉDICO (Carta Suficiente, Estatus Dictamen)", "warning");
    }
  }

  const onClickSendMedicInformation = async () => {
    await submitMedicalOpinionData();
    if (isEmpty(submitMedicalOpinionDataErrors)) {
      setSectionErrors(prev => ({ ...prev, medicalOpinionData: false }));
      let inputReasonMedicInformation = document.getElementById(
        "reason_sendToMedicInformation"
      ).value;
      if (inputReasonMedicInformation === "") {
        swal("Error", "Debe seleccionar una razón", "error");
        return;
      }

      if (inputReasonMedicInformation === "Informacion medica adicional") {
        let checkboxesMedicalDataAdditional = Array.prototype.slice.call(
          document.getElementsByName("additionalMedicInformation")
        );
        let someValueIsChecked = checkboxesMedicalDataAdditional.some(
          (checkbox) => checkbox.checked
        );
        if (!someValueIsChecked) {
          swal("Error", "Debes seleccionar un checkbox de Información Médica Adicional", "error");
          return;
        }
      }

      await submitMedicalDataAdditional();
      await submitMedicalOpinionData();
      if (!window.wasCommented) {
        setSectionErrors(prev => ({ ...prev, binnacle: true }));
        swal("Comentario requerido", "Debes guardar un comentario en la Bitácora antes de continuar", "warning");
        return;
      }
      setSectionErrors(prev => ({ ...prev, binnacle: false }));
      $("#btn_save_comment").click();
      let timestamp = await axios.get('/cases/localDateTime');
      update(
        { caseStatusId: 4, informationReason: inputReasonMedicInformation, feaimedica: moment.utc(timestamp.data).format() },
        caseRecord.id
      ).then((response) => {
        history.push("/dictamen_medico");
      });
    } else {
      setSectionErrors(prev => ({ ...prev, medicalOpinionData: true }));
      swal("Campos requeridos", "Completa los campos obligatorios en la sección DICTAMEN MÉDICO (Carta Suficiente, Estatus Dictamen)", "warning");
    }
  };

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        DICTAMEN MÉDICO
      </Alert>

      <CaseHeader
        caseRecord={caseRecord}
        hideComprehensiveCare={true}
        hideRequiresTabulation={true}
        hideHospitalModel={true}
        showFolioEp={true}
        showPolicy={true}
      />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
      <Accordion defaultActiveKey={query.has("from") && query.get("from") === "control_board" ? "" : "3"} className="mt-5">
        <InssuredData
          icon="fa-search"
          eventKey="1"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={() => {}}
        />
        <HospitalData
          icon="fa-search"
          eventKey="2"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={() => {}}
        />
        <MedicAssigned
          icon="fa-search"
          eventKey="7"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={() => {}}
        />
        <Documentation
          icon= "fa-search"
          icone="fa-pencil-alt"
          eventKey="4"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          allowSelectiveDownload={true}
          {...props}
        />
        <MedicalFees
          icon= "fa-search"
          icone="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          hideBtnInsurance={false}
          hideFormCreate={true}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          showForm={!query.has("from") && query.get("from") !== "control_board"}
          {...props}
        />
        <ProvidersData
            icon= "fa-pencil-alt"
            eventKey="6"
            data={caseRecord}
            disabled={false}
            disabledAll={true}
            {...props}
        />
        <AuthLetters
          icon="fa-pencil-alt"
          showForm={true}
          eventKey="3"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          setTotalLetters={setTotalLetters}
          allowDisableLetters={true}
          {...props}
        />
      </Accordion>
      <Accordion  defaultActiveKey={query.has("from") && query.get("from") === "control_board" ? "" : "0"} key={1} className="mt-5">
        { (IfHasRole("Admin") || IfHasRole("ADMINAXA") || IfHasRole("ADMIN_REGION_CELULA") ) && <MedicAssignationTrakingMedic
          icon="fa-pencil-alt"
          eventKey="0"
          data={caseRecord}
          mcMovement={letterMov}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={bindSubmitFormMedicAssignation}
          bindErrors={bindSubmitFormMedicAssignationErrors}
        /> }
        <MedicalOpinionData
          icon="fa-pencil-alt"
          setIsFinalReject={setIsFinalReject}
          eventKey="1"
          data={caseRecord}
          letterMov={letterMov}
          totalLetters={totalLetters}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={bindSubmitFormMedicalOpinionData}
          bindErrors={bindSubmitMedicalOpinionErrors}
          hasError={sectionErrors.medicalOpinionData}
          zurichDictumMode={true}
        />
        <MedicalDataAdditional
          icon="fa-pencil-alt"
          eventKey="6"
          data={caseRecord}
          disabled={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={bindSubmitFormMedicalDataAdditional}
          showOtherOption={true}
        />
      </Accordion>
      <Accordion defaultActiveKey="5" className="mt-5">
        <Binnacle
          icon="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          disabledAll={false}
          eventStage="Dictamen Medico"
          hasError={sectionErrors.binnacle}
          onCommentSaved={() => setSectionErrors(prev => ({ ...prev, binnacle: false }))}
          {...props}
        />
      </Accordion>
      </BlockCaseContext.Provider>

      <Row hidden={query.has("from") && query.get("from") === "control_board"}>
        {caseRecord.caseType !== "Revision de corte" &&
        <Col className="mt-5" hidden={isFinalReject}>
          <Button variant="warning" onClick={onClickSendMedicInformation}>
            Enviar a Informacion Médica Hospital
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToMedicInformation"
            id="reason_sendToMedicInformation"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Informacion medica adicional">
              Informacion medica adicional
            </option>
            <option value="Carta parcial">Carta parcial</option>
          </Form.Control>
        </Col>}

        {caseRecord.caseType !== "Revision de corte" &&
        <Col className="mt-5 mr-5" hidden={isFinalReject}>
          <Button variant="danger" onClick={onClickSendControlDesk}>
            Enviar a Mesa de Control
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToControlDesk"
            id="reason_sendToControlDesk"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Asignacion Incorrecta">Asignacion Incorrecta</option>
            <option value="Poliza VIP">Poliza VIP</option>
            <option value="Información Adicional">Información Adicional</option>
            <option value="Caso Inicial">Caso Inicial</option>
            <option value="Asignación Incorrecta VIP">Asignación Incorrecta VIP</option>
            <option value="Asignación Incorrecta VIP">Asignación Incorrecta Agil</option>
          </Form.Control>
        </Col>}

        <Col>
          <Button
            className="mt-5"
            variant="success"
            onClick={onClickCostControl}
          >
            Enviar a Control de Costos
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default MedicalOpinionDetails;
